module.exports = __webpack_public_path__ + "media/images/logos/instagram-6601ecb3a252a296e08218f18eb47d3a.svg";